<template>
  <div>
    <modal
      :show.sync="addChapter"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <!-- <template slot="modal-title">
        <h6 class="text-white pl-4 font-semibold">Add</h6>
      </template> -->
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Add Chapter
      </h6>
      <div>
        <base-input
          v-model="name"
          placeholder="Enter Chapter Name"
          class="cust-mb0"
          name="chapter"
        ></base-input>
        <!-- :rules="{ required: true }" -->
        <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
        <!-- <b-button type="primary"
          >Create Chapter</b-button -->
      </div>
      <template slot="footer">
        <base-button type="primary" @click="createChapter()"
          >ADD CHAPTER</base-button
        >
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    addChapter: Boolean,
    add_chapter: Function,
    course_id: String,
  },
  data() {
    return {
      name: "",
      // addChapter : false
      nameErr: false,
      msg: {},
    };
  },
  watch: {},
  methods: {
    async createChapter(name) {
      if (this.name.trim() !== "") {
        const loader = this.$loading();
        try {
          // if (this.name.split(" ")) {
          //   this.nameErr = true;
          //   this.msg.name = "Enter valid chapter name";
          // } else {
          const data = await this.$store.dispatch("eLearning/createChapter", {
            name: this.name.trim(),
            course: this.course_id,
          });
          if (data.code == 200) {
            this.$swal.fire({
              title: "Created",

              text: "Chapter has been created Successfully!",

              icon: "success",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2000,
            });
            this.closeModal();
          }
          // }
          loader.close();
        } catch (err) {
          loader.close();
          if (err.response.data.message.includes("duplicate key error")) {
            this.$swal.fire({
              title: "Error",

              text: "Chapter Name Already Exists!",

              icon: "warning",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2000,
            });
          }
        }
      } else {
        this.$swal.fire({
          title: "Error",
          text: "Please enter chapter name!",
          icon: "error",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        // this.closeModal();
      }
    },
    closeModal() {
      this.$emit("close-addChapter");
    },
  },
  computed: {
    ...mapState("eLearning", ["selectedCourse"]),
  },
};
</script>
